// pdf-reader.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import * as pdfjsLib from 'pdfjs-dist';

// Set worker source for PDF.js
 (pdfjsLib as any).GlobalWorkerOptions.workerSrc = 
   `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${(pdfjsLib as any).version}/pdf.worker.min.mjs`;

@Injectable({ providedIn: 'root' })
export class PdfReaderService {
  constructor(private http: HttpClient) {}

  /**
   * Fetches a PDF as Blob and counts its pages
   * @param url API endpoint returning PDF Blob
   */
  async countPdfPages(url: string): Promise<number> {
    try {
      // Fetch PDF as Blob
      const blob = await firstValueFrom(
        this.http.get(url, { responseType: 'blob' })
      );

      // Convert Blob to ArrayBuffer
      const arrayBuffer = await blob.arrayBuffer();

      // Load PDF document
      const pdf = await (pdfjsLib as any).getDocument({ data: arrayBuffer }).promise;

      // Return page count
      return pdf.numPages;
    } catch (error) {
      console.error('Error reading PDF:', error);
      throw new Error('Unable to read PDF');
    }
  }
  /**
   * Read Blob and counts its pages
   * @param url API endpoint returning PDF Blob
   */
  async countBlobPages(pdfBlob: Blob): Promise<number> {
    try {
      // Convert Blob to ArrayBuffer
      const arrayBuffer = await pdfBlob.arrayBuffer();

      // Load PDF document
      const pdf = await (pdfjsLib as any).getDocument({ data: arrayBuffer }).promise;

      // Return page count
      return pdf.numPages;
    } catch (error) {
      console.error('Error reading PDF:', error);
      throw new Error('Unable to read PDF');
    }
  }
}
